"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = calculateTotalPay;
exports.calculateTotalStipend = calculateTotalStipend;
exports.calculateTotalBonus = calculateTotalBonus;
const number_utils_1 = require("./number-utils");
/**
 * Calculates total nurse pay without needing to subtract out fees.
 *
 * @return Total nurse pay.
 */
function calculateTotalPay({ payRate, minutesWorked, stipend = 0, bonus = 0, }) {
    return Math.round(payRate * (0, number_utils_1.roundToAtMostTwoDecimals)(minutesWorked / 60) + stipend + bonus);
}
const sumAmounts = (items) => items ? items.reduce((total, item) => item.amount + total, 0) : 0;
function calculateTotalStipend(stipends) {
    return sumAmounts(stipends);
}
function calculateTotalBonus(bonuses) {
    return sumAmounts(bonuses);
}
//# sourceMappingURL=pay-calculator.js.map